module.exports = __webpack_public_path__ + "img/logo.11e2955c.png";